import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const certificateTemplateFields = {
  id: true,
  title: true,
  body: true,
  signature: true,
  showScore: true,
  showDate: true,
  showTotalTime: true,
  logo: true,
  orientation: true,
  hasSkeleton: true,
  marginTop: true,
  marginBottom: true,
  marginLeft: true,
  marginRight: true,
} as const

export const GQL_CERTIFICATE_TEMPLATE = typedGql('query', { scalars })({
  certificateTemplate: certificateTemplateFields,
})

export const GQL_UPDATE_CERTIFICATE_TEMPLATE = typedGql('mutation', { scalars })({
  updateCertificateTemplate: [
    { input: $('input', 'UpdateCertificateTemplateInput!') },
    certificateTemplateFields,
  ],
})
